import { createContext, useContext, useEffect, useState } from "react";
import { TRANSLATIONS } from "@/data/site";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(
    () => localStorage.getItem("acu_lang") || "es"
  );

  useEffect(() => {
    localStorage.setItem("acu_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const toggle = () => setLang((l) => (l === "es" ? "en" : "es"));
  const t = TRANSLATIONS[lang];

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggle, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLang = () => useContext(LanguageContext);
